import styled from "styled-components";

const MyDiv = styled.div`
  .fc {
    font-family: "Poppins", sans-serif;
    font-size: 12px;
  }

  .fc .fc-scrollgrid {
    border: 1px solid #eee;
    border-radius: 6px;
    overflow: hidden;
  }

  .fc-theme-standard td,
  .fc-theme-standard th {
    border: 1px solid #eee;
  }

  /* Center date number */
  .fc .fc-daygrid-day-top {
    justify-content: center;
  }

  .fc .fc-daygrid-day-number {
    float: none;
    margin: 0 auto;
    font-weight: 500;
  }

  /* Compact cell */
  .fc .fc-daygrid-day-frame {
    min-height: 140px;
    padding: 31px;
  }

  /* Event card */
  .calendar-event {
    background: gray.600;

    padding: 4px 10px;
    margin-top: 4px;
    cursor: pointer;
  }

  .fc .fc-daygrid-day.fc-day-today {
    background-color: #eef3fb;
  }
`;

export default MyDiv;
